'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["conversation", "selected", "unread", "focused", "ownerState", "slots", "slotProps"];
import * as React from 'react';
import useSlotProps from '@mui/utils/useSlotProps';
import { jsx as _jsx } from "react/jsx-runtime";
function formatUnreadCount(count) {
  return count > 99 ? '99+' : count;
}
export const ConversationListUnreadBadge = /*#__PURE__*/React.forwardRef(function ConversationListUnreadBadge(props, ref) {
  const _ref = props,
    {
      conversation,
      selected = false,
      unread = false,
      focused = false,
      ownerState: ownerStateProp,
      slots,
      slotProps
    } = _ref,
    other = _objectWithoutPropertiesLoose(_ref, _excluded);
  const ownerState = {
    conversation,
    selected,
    unread,
    focused,
    variant: ownerStateProp?.variant ?? 'default'
  };
  void ownerStateProp;
  const Root = slots?.root ?? 'span';
  const rootProps = useSlotProps({
    elementType: Root,
    externalSlotProps: slotProps?.root,
    externalForwardedProps: other,
    ownerState,
    additionalProps: {
      ref
    }
  });
  const unreadCount = conversation.unreadCount != null && conversation.unreadCount > 0 ? conversation.unreadCount : null;

  // In compact mode, render a dot indicator for any unread state (even without a numeric count).
  if (ownerState.variant === 'compact') {
    if (!unread) {
      return null;
    }
    return /*#__PURE__*/_jsx(Root, _extends({}, rootProps, {
      children: unreadCount != null ? formatUnreadCount(unreadCount) : ''
    }));
  }
  if (!unreadCount) {
    return null;
  }
  return /*#__PURE__*/_jsx(Root, _extends({}, rootProps, {
    children: unreadCount > 99 ? '99+' : unreadCount
  }));
});
if (process.env.NODE_ENV !== "production") ConversationListUnreadBadge.displayName = "ConversationListUnreadBadge";